import { lazy } from "react"

// pdf.js is large, so it loads only when a screen draws a document.
export const LazyPdfPages = lazy(() => import("./PdfPages.tsx"))

export { FieldLayer, positionOf } from "./FieldLayer.tsx"
export type { PdfPagesProps } from "./PdfPages.tsx"
